export default __webpack_public_path__ + "static/media/pathwayAuth.15811a67.png";